import { render, staticRenderFns } from "./StatsLostMapSource.vue?vue&type=template&id=2bda2837&scoped=true"
import script from "./StatsLostMapSource.vue?vue&type=script&lang=js"
export * from "./StatsLostMapSource.vue?vue&type=script&lang=js"
import style0 from "./StatsLostMapSource.vue?vue&type=style&index=0&id=2bda2837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda2837",
  null
  
)

export default component.exports